import { Controller } from "@hotwired/stimulus"

// Auto-fills the slug from the title field, but stops as soon as the user
// edits the slug manually so we never clobber their work.
export default class extends Controller {
  static targets = ["title", "slug"]

  connect() {
    this._dirty = this.slugTarget.value.trim().length > 0
    this.slugTarget.addEventListener("input", () => { this._dirty = true })
  }

  sync() {
    if (this._dirty) return
    this.slugTarget.value = this.slugify(this.titleTarget.value)
  }

  slugify(input) {
    return input.toString().toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
  }
}
